export const handleGetError = (err, props) => {
    if (err.response && err.response.status === 404) {
        props.history.push(`/`);
    }
};